import {
    anObjectReferralCRUD,
    contractRequestCRUD,
    prescriptionCRUD,
    referralCRUD,
    resolutionCRUD,
} from "../../http/CRUD";
import {
    CONTRACT_REQUEST_ROUTE,
    OBJECT_REFERRAL_ROUTE,
    REFERRAL_ROUTE,
} from "../../routes/const";

export const ADMIN_PANEL_ENTITIES = [
    {
        key: "referral",
        label: "Платные заявки",
        description: "Единоразовые заявки (платные)",
        crud: referralCRUD,
        detailRoute: (id) => REFERRAL_ROUTE(id),
        subtitle: (row) => row?.patient?.fullName || row?.targetObject?.name || "",
    },
    {
        key: "anObjectReferral",
        label: "Заявки по госзаказу",
        description: "Заявки по государственному заказу",
        crud: anObjectReferralCRUD,
        detailRoute: (id) => OBJECT_REFERRAL_ROUTE(id),
        subtitle: (row) => row?.targetObject?.name || "",
    },
    {
        key: "contractRequest",
        label: "Сводные заявки",
        description: "Сводные заявки (контрактные)",
        crud: contractRequestCRUD,
        detailRoute: (id) => CONTRACT_REQUEST_ROUTE(id),
        subtitle: (row) => row?.name || row?.client?.name || "",
    },
    {
        key: "resolution",
        label: "Постановления",
        description: "Постановления КСЭК",
        crud: resolutionCRUD,
        detailRoute: (id) => `/resolution/${id}`,
        subtitle: (row) => row?.targetObject?.name || "",
    },
    {
        key: "prescription",
        label: "Предписания",
        description: "Предписания КСЭК",
        crud: prescriptionCRUD,
        detailRoute: (id) => `/prescription/${id}`,
        subtitle: (row) => row?.targetObject?.name || "",
    },
];
